export default "__VITE_ASSET__MHg7xBYR__"